import { z } from 'zod';

export const selectedItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  price: z.number(),
});

export type PricedItem = z.infer<typeof selectedItemSchema>;
